export default __webpack_public_path__ + "static/HelveticaMonospacedPro-Rg-640cf5e91d92d1d0758ecc3311e47987.woff";